import React from 'react';
import { Nav } from 'react-bootstrap';
import { FaFacebookF, FaTwitter, FaYoutube, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      {/* Main Footer with glossy effect */}
      <footer id="footer" style={{ 
        backgroundColor: '#DCDCDC', 
        backgroundImage: 'linear-gradient(to bottom, #e6e6e6, #d4d4d4, #DCDCDC)',
        boxShadow: '0 -4px 12px rgba(0,0,0,0.05)',
        borderTop: '1px solid rgba(255,255,255,0.6)'
      }} className="text-black pt-5 pb-4">
        <div className="container-fluid">
          <div className="row px-md-5">

            {/* Column 1: Logo and Company Details */}
            <div className="col-md-3 footer-column mb-4 mb-md-0">
              <div className="logo-footer mb-4">
                <a className="navbar-brand me-0" href="index.html" title="Axis Fincorp" rel="home">
                  <img alt="Axis Fincorp" src="newlogo.svg" className="img-fluid" style={{ maxHeight: '50px' }} />
                </a>
              </div>
              <p style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                We value your time, and our streamlined processes reflect that. aditya birla finance capital ensures quick and hassle-free loan approvals, empowering you to achieve your financial goals without delay.
              </p>
            </div>

            {/* Column 2: Explore */}
            <div className="col-md-2 footer-column mb-4 mb-md-0 offset-md-1">
              <h5 style={{ 
                fontSize: '1.1rem', 
                fontWeight: '600',
                marginBottom: '1.2rem',
                position: 'relative',
                paddingBottom: '0.5rem'
              }} 
              className="border-bottom border-secondary border-2 d-inline-block">
                Explore
              </h5>
              <ul className="list-unstyled">
                <li className="mb-2"><a className="text-black text-decoration-none" style={{ fontSize: '0.95rem', transition: 'all 0.3s' }} onMouseOver={(e) => e.target.style.color = '#8B0000'} onMouseOut={(e) => e.target.style.color = 'black'}>How it works</a></li>
                <li className="mb-2"><a className="text-black text-decoration-none" style={{ fontSize: '0.95rem', transition: 'all 0.3s' }} onMouseOver={(e) => e.target.style.color = '#8B0000'} onMouseOut={(e) => e.target.style.color = 'black'}>Loan Eligibility</a></li>
                <li className="mb-2"><a className="text-black text-decoration-none" style={{ fontSize: '0.95rem', transition: 'all 0.3s' }} onMouseOver={(e) => e.target.style.color = '#8B0000'} onMouseOut={(e) => e.target.style.color = 'black'}>Loan Calculator</a></li>
                <li className="mb-2"><a className="text-black text-decoration-none" style={{ fontSize: '0.95rem', transition: 'all 0.3s' }} onMouseOver={(e) => e.target.style.color = '#8B0000'} onMouseOut={(e) => e.target.style.color = 'black'}>Contact</a></li>
              <Link to="/admin" className="text-black text-decoration-none" style={{ fontSize: '0.95rem', transition: 'all 0.3s' }} onMouseOver={(e) => e.target.style.color = '#8B0000'} onMouseOut={(e) => e.target.style.color = 'black'}>
                    Admin
                  </Link>
              </ul>
            </div>

            {/* Column 3: Help & Support */}
            <div className="col-md-2 footer-column mb-4 mb-md-0">
              <h5 style={{ 
                fontSize: '1.1rem', 
                fontWeight: '600',
                marginBottom: '1.2rem',
                position: 'relative',
                paddingBottom: '0.5rem'
              }} 
              className="border-bottom border-secondary border-2 d-inline-block">
                Support
              </h5>
              <ul className="list-unstyled">
                <li className="mb-2"><a className="text-black text-decoration-none" style={{ fontSize: '0.95rem', transition: 'all 0.3s' }} onMouseOver={(e) => e.target.style.color = '#8B0000'} onMouseOut={(e) => e.target.style.color = 'black'}>Privacy Policy</a></li>
                <li className="mb-2"><a className="text-black text-decoration-none" style={{ fontSize: '0.95rem', transition: 'all 0.3s' }} onMouseOver={(e) => e.target.style.color = '#8B0000'} onMouseOut={(e) => e.target.style.color = 'black'}>Terms & Conditions</a></li>
                <li className="mb-2">
                  <Link to="/refund" className="text-black text-decoration-none" style={{ fontSize: '0.95rem', transition: 'all 0.3s' }} onMouseOver={(e) => e.target.style.color = '#8B0000'} onMouseOut={(e) => e.target.style.color = 'black'}>
                    Refund & Cancellation
                  </Link>
                </li>
                <li className="mb-2"><a className="text-black text-decoration-none" style={{ fontSize: '0.95rem', transition: 'all 0.3s' }} onMouseOver={(e) => e.target.style.color = '#8B0000'} onMouseOut={(e) => e.target.style.color = 'black'}>Disclaimer</a></li>
                <li className="mb-2"><a className="text-black text-decoration-none" style={{ fontSize: '0.95rem', transition: 'all 0.3s' }} onMouseOver={(e) => e.target.style.color = '#8B0000'} onMouseOut={(e) => e.target.style.color = 'black'}>FAQ</a></li>
              </ul>
            </div>

            {/* Column 4: Contact Info */}
            <div className="col-md-3 footer-column mb-4 mb-md-0 offset-md-1">
              <h5 style={{ 
                fontSize: '1.1rem', 
                fontWeight: '600',
                marginBottom: '1.2rem',
                position: 'relative',
                paddingBottom: '0.5rem'
              }} 
              className="border-bottom border-secondary border-2 d-inline-block">
                Contact Us
              </h5>
              <div className="d-flex align-items-start mb-3">
                <FaEnvelope className="mt-1 me-2" style={{ color: '#8B0000', minWidth: '16px' }} />
                <a href="mailto:care@adityabirlafinances.com" className="text-black text-decoration-none" style={{ fontSize: '0.95rem' }}>
                  care@adityabirlafinances.com
                </a>
              </div>
              {/* <div className="d-flex align-items-start mb-3">
                <FaPhone className="mt-1 me-2" style={{ color: '#8B0000', minWidth: '16px' }} />
                <a href="tel:+919842346458" className="text-black text-decoration-none" style={{ fontSize: '0.95rem' }}>
                  +91 9842 34 6458
                </a>
              </div> */}
              <div className="d-flex align-items-start">
                <FaMapMarkerAlt className="mt-1 me-2" style={{ color: '#8B0000', minWidth: '16px' }} />
                <div>
                  <p className="mb-1" style={{ fontSize: '0.95rem' }}>Aditya Birla Finance</p>
                  <p className="mb-1" style={{ fontSize: '0.95rem' }}>C/24, 1st, 2nd, 3rd Floor</p>
                  <p className="mb-1" style={{ fontSize: '0.95rem' }}>Ashok Marg, C Scheme</p>
                  <p className="mb-0" style={{ fontSize: '0.95rem' }}>Jaipur - 302001</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Bottom Strip with glossy dark red */}
      <div style={{ 
        backgroundColor: '#8B0000',
        backgroundImage: 'linear-gradient(to bottom, #a00000, #8B0000, #700000)',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.2)'
      }} className="text-white py-3">
        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
          {/* Left: Social Icons */}
          <div className="d-flex gap-3 mb-2 mb-md-0">
            <a href="https://facebook.com" className="text-white fs-5" style={{ 
              transition: 'all 0.3s',
              padding: '8px',
              borderRadius: '50%',
              backgroundColor: 'rgba(255,255,255,0.1)',
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} onMouseOver={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.2)';
              e.target.style.transform = 'translateY(-2px)';
            }} onMouseOut={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
              e.target.style.transform = 'translateY(0)';
            }}>
              <FaFacebookF />
            </a>
            <a href="https://twitter.com" className="text-white fs-5" style={{ 
              transition: 'all 0.3s',
              padding: '8px',
              borderRadius: '50%',
              backgroundColor: 'rgba(255,255,255,0.1)',
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} onMouseOver={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.2)';
              e.target.style.transform = 'translateY(-2px)';
            }} onMouseOut={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
              e.target.style.transform = 'translateY(0)';
            }}>
              <FaTwitter />
            </a>
            <a href="https://youtube.com" className="text-white fs-5" style={{ 
              transition: 'all 0.3s',
              padding: '8px',
              borderRadius: '50%',
              backgroundColor: 'rgba(255,255,255,0.1)',
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} onMouseOver={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.2)';
              e.target.style.transform = 'translateY(-2px)';
            }} onMouseOut={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
              e.target.style.transform = 'translateY(0)';
            }}>
              <FaYoutube />
            </a>
            <a href="https://instagram.com" className="text-white fs-5" style={{ 
              transition: 'all 0.3s',
              padding: '8px',
              borderRadius: '50%',
              backgroundColor: 'rgba(255,255,255,0.1)',
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} onMouseOver={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.2)';
              e.target.style.transform = 'translateY(-2px)';
            }} onMouseOut={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
              e.target.style.transform = 'translateY(0)';
            }}>
              <FaInstagram />
            </a>
          </div>

          {/* Right: Copyright */}
          <div style={{ fontSize: '0.9rem' }}>
            © {new Date().getFullYear()} aditya birla finance capital. All Rights Reserved.
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;